import { render, staticRenderFns } from "./AddGift.vue?vue&type=template&id=1b253d49&scoped=true"
import script from "./AddGift.vue?vue&type=script&lang=js"
export * from "./AddGift.vue?vue&type=script&lang=js"
import style0 from "./AddGift.vue?vue&type=style&index=0&id=1b253d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b253d49",
  null
  
)

export default component.exports